var map = {
	"./game2win/brand-logo.png": 9392,
	"./goal-gambit/brand-logo.png": 5036,
	"./mtn-checkmate-rush/brand-logo.png": 1312,
	"./mtn-mzansi-rhythm/brand-logo.png": 4079,
	"./mtn-unlock-more/brand-logo.png": 5430,
	"./mtn-unlock-yellow/brand-logo.png": 4687,
	"./mtn-yellow-rush/brand-logo.png": 805,
	"./wp-gem-queens/brand-logo.png": 723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6590;